/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import e from"../core/has.js";const a=()=>!!e("enable-feature:force-wosr"),r=()=>!!e("enable-feature:disable-context-navigation"),t=()=>!!e("enable-feature:direct-3d-object-feature-layer-display");export{r as disableContextNavigation,t as enableDirect3DObjectFeatureLayerDisplay,a as enableWebStyleForceWOSR};
